class HeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    if (this.slides.length === 0) return;

    this.index = 0;
    this.interval = (parseFloat(this.dataset.autoplaySpeed) || 6) * 1000;
    this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.prev = this.querySelector('[data-prev]');
    this.next = this.querySelector('[data-next]');
    this.dotWrap = this.querySelector('[data-dots]');

    if (this.slides.length > 1) {
      this.prev?.addEventListener('click', () => this.step(-1, true));
      this.next?.addEventListener('click', () => this.step(1, true));
      this.buildDots();
      this.bindSwipe();
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.step(-1, true);
        if (e.key === 'ArrowRight') this.step(1, true);
      });
    } else {
      this.prev?.remove();
      this.next?.remove();
      this.dotWrap?.remove();
    }

    this.show(0);
    this.start();

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    this.onVisibility = () => (document.hidden ? this.stop() : this.start());
    document.addEventListener('visibilitychange', this.onVisibility);
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);
  }

  buildDots() {
    if (!this.dotWrap) return;
    this.dots = this.slides.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'hero-slideshow__dot';
      b.setAttribute('aria-label', `Slide ${i + 1}`);
      b.addEventListener('click', () => this.show(i, true));
      this.dotWrap.appendChild(b);
      return b;
    });
  }

  bindSwipe() {
    let x0 = null;
    this.addEventListener('touchstart', (e) => { x0 = e.changedTouches[0].clientX; }, { passive: true });
    this.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) this.step(dx < 0 ? 1 : -1, true);
      x0 = null;
    }, { passive: true });
  }

  step(direction, byUser) {
    const n = this.slides.length;
    this.show((this.index + direction + n) % n, byUser);
  }

  show(i, byUser) {
    this.index = i;
    this.slides.forEach((slide, n) => {
      const active = n === i;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      slide.querySelectorAll('a, button').forEach((el) => {
        el.tabIndex = active ? 0 : -1;
      });
    });
    this.dots?.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
    if (byUser) this.restart();
  }

  start() {
    if (!this.autoplay || this.reduced || this.timer) return;
    this.timer = setInterval(() => this.step(1), this.interval);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }
}

if (!customElements.get('hero-slideshow')) {
  customElements.define('hero-slideshow', HeroSlideshow);
}
